<relogin-handling></relogin-handling>
<div #appContainer class="dna-page" >
  <header #appHeader class="app-header" id="appHeader">
    <div class="dna-header-body">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <span class="dna-header-icon"></span>
          <h2 class="dna-header-title" id="appTitle">{{ 'FRAGEBOEGEN_APP.APP_NAME' | translate }}</h2>
        </div>
        <div class="d-flex align-items-center">
          <div class=" app-header-servicekontakt pr-2x">
            <a class="d-flex align-items-center"
               [href]="fseLink"
               id="servicekontaktLink" rel="noopener noreferrer" target="_blank"
               title="{{ 'FRAGEBOEGEN_APP.HELP' | translate }}">
              <em class="icon app-header-help-icon mr-1x mt-1"></em>
              <span>{{ 'FRAGEBOEGEN_APP.HELP' | translate }}</span>
            </a>
          </div>
          <div *ngIf="!isDAPHeaderSettings" class="">
            <datev-app-switch class="text-sm"></datev-app-switch>
          </div>
          <datev-usermenu *ngIf="isLoggedIn && !isDAPHeaderSettings"></datev-usermenu>
        </div>
      </div>
    </div>
    <div class="dna-alert-wrapper">
      <datev-notification-outlet></datev-notification-outlet>
    </div>
    <div #messageBanners>
      <div id="message-banner" class="message-banner" *ngIf="showGeneralBanner$ | async">
        <div class="common-ui-card-img"><em class="icon icon-svg icon-fi-info mr-1x"></em></div>
        <div class="text-container">
          <span class="bold-text">
            {{ 'COMMON_UI.GENERAL_MESSAGE_BANNER.TEXT' | translate }}
          </span>
        </div>
        <button class="btn icon-close position-absolute"  style="right: 0.3rem;top: 0.3rem;" (click)="closeBanner()"></button>
      </div>
    </div>
  </header>
  <main class="container-fluid" *ngIf="isLoggedIn else waitForLogin">
    <router-outlet></router-outlet>
  </main>
  <ng-template #waitForLogin></ng-template>
</div>
<div [ngClass]="{'show-modal': loadingService.isLoading.isLoading}" class="modal">
  <common-ui-loader [position]="'center'" [size]="'lg'"></common-ui-loader>
</div>
